import type {CareersGlobal} from '~/payload-types'

export function useCareersMeta() {
  const sdk = usePayloadSdk()
  const route = useRoute()

  const fetch = async () => {
    const result = await sdk.findGlobal({
      slug: 'careersGlobal',
      depth: 1,
      draft: !!route.query.preview,
    })
    return result as CareersGlobal
  }

  return {fetch}
}
